import { render, staticRenderFns } from "./UsuarioPivotTable.vue?vue&type=template&id=64e7647a"
import script from "./UsuarioPivotTable.vue?vue&type=script&lang=js"
export * from "./UsuarioPivotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports